import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
// import VueApexCharts from 'vue-apexcharts'
// import Vuelidate from 'vuelidate'
// import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'
import Scrollspy from 'vue2-scrollspy'
import VueSweetalert2 from 'vue-sweetalert2'
import underscore from 'vue-underscore'
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)
Vue.use(underscore)
import { FormatQty } from '@/helpers/utils/format-qty.js'

import "@/design/index.scss"
import "@/assets/css/defaultTheme.css"
import "@/assets/css/custom.css"
import 'vue-search-select/dist/VueSearchSelect.css'

import store from '@/state/store'

import App from './App.vue'

import i18n from './i18n'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

import Multiselect from "vue-multiselect"
Vue.component('multiselect', Multiselect)
// Adding Instance Properties
import * as utils from '@/helpers/utils/utils'
Vue.prototype.$utils = utils

import tinymce from 'vue-tinymce-editor'
// import 'devextreme/dist/css/dx.common.css'
// import 'devextreme/dist/css/dx.light.css'
// import '@devexpress/analytics-core/dist/css/dx-analytics.common.css'
// import '@devexpress/analytics-core/dist/css/dx-analytics.light.css'
// import '@devexpress/analytics-core/dist/css/dx-querybuilder.css'
// import 'devexpress-reporting/dist/css/dx-webdocumentviewer.css'
// import 'devexpress-reporting/dist/css/dx-reportdesigner.css'
import * as validate from '@/helpers/utils/validate'
Vue.prototype.$validate = validate

import "@/helpers/vee-validate"
Vue.component('tinymce', tinymce)

Vue.use(VueRouter)
Vue.use(vco)
Vue.use(Scrollspy);
const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.config.productionTip = false

Vue.use(BootstrapVue)
// Vue.use(Vuelidate)
Vue.use(VueMask)
// Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
//     libraries: 'places',
//   },
//   installComponents: true
// })
// Vue.component('apexchart', VueApexCharts)

// Create Directive v-can for check permission by element
Vue.directive('can', {
  // When the bound element is inserted into the DOM...
  inserted (el, binding, vnode) {
    const permissionList = store.getters['auth/getApiPermission']
    const checkPermissionFlag = store.getters['auth/getCheckPermissionByElementFlag']
    if (JSON.parse(checkPermissionFlag)) {
      if (typeof (binding.value) === 'object') { //case multi permission in element
        let matchFlag = false
        permissionList.forEach(permission => {
          if (binding.value.filter(element => {
            return element === permission
          }).length !== 0) matchFlag = true
        })
        if (!matchFlag) vnode.elm.parentElement.removeChild(vnode.elm)
      } else { //case single permission in element
        let matchFlag = false
        permissionList.forEach(permission => {
          if (permission === binding.value) matchFlag = true
        })
        if (!matchFlag) vnode.elm.parentElement.removeChild(vnode.elm)
      }
    }
  }
})

Vue.filter('number', function(value) {
  return FormatQty(value)
})

export const eventBus = new Vue()

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
